module.exports = {
      id: "fb-usage",
      viewBox: "0 0 20 20",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#fb",
      toString: function () {
        return this.url;
      }
    }